import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {
	return {
		popoverDropdown: {
			padding      : "0",
			border       : "0",
			borderRadius : "2rem !important",
			marginTop    : "70px"
		},
		controlsRoot: {
			display        : "flex",
			flexDirection  : "column",
			zIndex         : 4,
			alignItems     : "center",
			justifyContent : "end",
			gap            : "3rem",
			margin         : "0 1rem",

			[rooterMediaQuery.mobile]: {
				margin      : "0rem",
				marginRight : "1rem",
				right       : "0rem",
				bottom      : "0rem",
				position    : "absolute"
			}
		},

		reportFollowModalWrapper: {
			margin: "0 auto"
		},
		text: {
			fontSize                  : "1.2rem",
			[rooterMediaQuery.mobile] : {
				fontSize : "1.3rem",
				color    : theme.other.paletteNew.secondaryWhite
			}
		},
		commentDrawerContent: {
			height     : "fit-content !important",
			background : "none"
		},
		iconWrapper: {
			display        : "flex",
			flexDirection  : "column",
			gap            : "0.6rem",
			alignItems     : "center",
			justifyContent : "space-between",

			[rooterMediaQuery.mobile]: {
				gap: "0rem"
			}
		},
		controlsWrapperInner: {
			display        : "flex",
			flexDirection  : "column",
			gap            : "2rem",
			alignItems     : "center",
			justifyContent : "center"
		},
		controlsIcon: {
			border          : "none",
			padding         : "0.8rem",
			borderRadius    : "50%",
			display         : "flex",
			background      : theme.other.paletteNew.darkModeDarkGrey20,
			alignItems      : "center",
			justifyContent  : "center",
			cursor          : "pointer",
			zIndex          : 50,
			transformOrigin : "bottom-center",

			"&[data-active]": {
				background: theme.other.darkMode ? theme.other.paletteNew.darkModeWhite20 : theme.other.paletteNew.secondaryDarkGrey50
			},

			"&[data-liked=\"true\"]": {
				animation: "likeAnimation 0.4s ease-in-out"
			},

			[ rooterMediaQuery.mobile ]: {
				padding    : "0.4rem",
				background : "none"
			},

			"@keyframes likeAnimation": {
				"0%": {
					scale     : "1",
					transform : "translateY(0%)",
					rotate    : "8deg"
				},
				"25%": {
					scale  : "1.2",
					rotate : "-8deg"
				},
				"50%": {
					transform: "translateY(-10%)"
				},
				"75%": {
					scale  : "1.2",
					rotate : "8deg"
				},
				"100%": {
					scale     : "1",
					transform : "translateY(0%)",
					rotate    : "0deg"
				}
			}
		},
		controlsWrapper: {
			display        : "flex",
			flexDirection  : "column",
			gap            : "1.6rem",
			alignItems     : "center",
			justifyContent : "center",

			[rooterMediaQuery.mobile]: {
				justifyContent: "end"
			}
		}
	};
} );